var host = globalThis.OpenLeaf;
var ns = host && host.__runtime && host.__runtime["prosemirror-model"];
if (!ns) throw new Error("openleaf: prosemirror-model is not on the host runtime. Load openleaf.min.js before this bundle.");
module.exports = ns;
